import { createContext, use } from 'react';

type SessionContextType = {
  isAuthenticated: boolean;
  signingInWithWallet: boolean;
  signInWithWallet: () => Promise<void>;
};

export const SessionContext = createContext<SessionContextType | undefined>(
  undefined
);

export const useSession = () => {
  const context = use(SessionContext);
  if (!context) {
    throw new Error('useSession should be used inside SessionProvider');
  }
  return context;
};
